import classNames from 'classnames';
import { FormikContextType, FormikValues } from 'formik';
import React from 'react';

import MSpinner from 'views/MSpinner/MSpinner';

import classes from './MFormContent.module.scss';

type Props<Fields extends FormikValues> = {
  className?: string;
  contentClassName?: string;
  formik: FormikContextType<Fields>;
  isLoading?: boolean;
  isFullScreen?: boolean;
};

const MFormContentView = <Fields extends FormikValues>(props: React.PropsWithChildren<Props<Fields>>): JSX.Element => {
  return (
    <form className={classNames(classes['container'], props.className)} onSubmit={props.formik.handleSubmit}>
      <div
        className={classNames(classes['content'], props.contentClassName, {
          [classes['content--fullScreen']]: props.isFullScreen,
        })}
      >
        {props.isLoading ? <MSpinner size="md"></MSpinner> : props.children}
      </div>
    </form>
  );
};

MFormContentView.displayName = 'MFormContentView';
MFormContentView.defaultProps = {};

export default MFormContentView;
